import {
  Background,
  Base,
  ClarityBlue,
  ClarityGreen,
  ClarityOrange,
  ClarityPurple,
  ClarityRed,
  Content,
  Grey,
} from './colours.constants';

export const HexShade = {
  50: 50,
  100: 100,
  200: 200,
  300: 300,
  400: 400,
  500: 500,
  600: 600,
  700: 700,
  800: 800,
  900: 900,
} as const;
export type HexShade = keyof typeof HexShade;

export type HexPalette = Record<HexShade, string>;

export const ClarityColour = {
  Background,
  Base,
  Content,
  Grey,
  Blue: ClarityBlue,
  Purple: ClarityPurple,
  Red: ClarityRed,
  Orange: ClarityOrange,
  Green: ClarityGreen,
} as const;

export type ClarityColourMap = typeof ClarityColour;
export type ClarityColourPalette = keyof ClarityColourMap;

export const ClarityShade = {
  Backdrop: 'Backdrop',
  Surface: 'Surface',
  ExtraSoft: 'ExtraSoft',
  Soft: 'Soft',
  Medium: 'Medium',
  Hard: 'Hard',
  Midnight: 'Midnight',
} as const;
export type ClarityShadeKey = keyof typeof ClarityShade;
